function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 59"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3.665951 2.516949 C 4.248893 2.516949 4.721549 2.065413 4.721549 1.508276 C 4.721549 0.951139 4.248893 0.500331 3.665951 0.500331 C 3.083008 0.500331 2.610352 0.951139 2.610352 1.508276 C 2.610352 2.065413 3.083008 2.516949 3.665951 2.516949 Z M 3.665951 2.516949 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 6.833464 10.501126 C 6.250521 10.501126 5.777865 10.04959 5.777865 9.492452 C 5.777865 8.935315 6.250521 8.484507 6.833464 8.484507 C 7.417122 8.484507 7.889063 8.935315 7.889063 9.492452 C 7.889063 10.04959 7.417122 10.501126 6.833464 10.501126 Z M 6.833464 10.501126 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.722266 1.507548 L 10.00026 1.507548 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.777865 9.492452 L 0.49987 9.492452 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.49987 1.507548 L 2.611068 1.507548 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.00026 9.492452 L 7.889063 9.492452 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 6.832747 6.551642 C 7.41569 6.551642 7.888346 6.100834 7.888346 5.543697 C 7.888346 4.98656 7.41569 4.535024 6.832747 4.535024 C 6.249805 4.535024 5.777148 4.98656 5.777148 5.543697 C 5.777148 6.100834 6.249805 6.551642 6.832747 6.551642 Z M 6.832747 6.551642 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.777865 5.542969 L 0.49987 5.542969 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.00026 5.542969 L 7.889063 5.542969 ",
    transform: "matrix(5.454545,0,0,5.363636,0,0)"
  })));
};
export default SvgFilters;